export default [
    // {
    //     path: '/404',
    //     name: '404',
    //     component: () => import('@/views/404'),
    // },
    {
        path: '/zh',
        redirect: '/', //重定向
    },
    {
        path: '/',
        name: '首页',
        component: () => import('@/views/home'),
    },
    {
        path: '/detail/:menuId',
        // name: '内容页',
        component: () => import('@/views/container'),
        children: [
            {
                path: '',
                name: '图文',
                component: () => import('@/views/detail'),
            }
        ]
    },
    {
        path: '/list/:id',
        // name: '列表页',
        component: () => import('@/views/container'),
        children: [
            {
                path: '',
                name: '列表',
                component: () => import('@/views/list'),
            },
            {
                path: 'detail/:Listid',
                name: '列表图文',
                component: () => import('@/views/detail'),
            }
        ]
    },
    {
        path: '/photo/:id',
        // name: '照片页',
        component: () => import('@/views/container'),
        children: [
            {
                path: '',
                name: '照片列表',
                component: () => import('@/views/photo'),
            }
        ]
    },
    {
        path: '/repair/:id',
        // name: '投诉报修页',
        component: () => import('@/views/container'),
        children: [
            {
                path: '',
                name: '投诉报修',
                component: () => import('@/views/repair'),
            },
            {
                path: 'detail/:listId',
                name: '投诉报修详情',
                component: () => import('@/views/repairDetail'),
            }
        ]
    },
    {
        path: '/contact/:id',
        // name: '联系方式页',
        component: () => import('@/views/container'),
        children: [
            {
                path: '',
                name: '联系方式',
                component: () => import('@/views/contact'),
            },
        ]
    },
    {
        path: '/message/:id',
        // name: '留言页',
        component: () => import('@/views/container'),
        children: [
            {
                path: '',
                name: '留言',
                component: () => import('@/views/message'),
            },
        ]
    },
]
